module.exports = __webpack_public_path__ + "static/img/brand-me-downtown.17b3c07.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand-me-downtown.jpg
// module id = mTcE
// module chunks = 1